import request from '@/utils/request'

// 租户管理API

// 分页查询租户列表
export function listTenants(params) {
  return request({
    url: '/api/admin/tenants',
    method: 'get',
    params
  })
}

// 获取租户详情
export function getTenant(tenantId) {
  return request({
    url: `/api/admin/tenants/${tenantId}`,
    method: 'get'
  })
}

// 创建租户
export function createTenant(data) {
  return request({
    url: '/api/admin/tenants',
    method: 'post',
    data
  })
}

// 更新租户
export function updateTenant(tenantId, data) {
  return request({
    url: `/api/admin/tenants/${tenantId}`,
    method: 'put',
    data
  })
}

// 删除租户
export function deleteTenant(tenantId) {
  return request({
    url: `/api/admin/tenants/${tenantId}`,
    method: 'delete'
  })
}

// 更新租户状态
export function updateTenantStatus(tenantId, status) {
  return request({
    url: `/api/admin/tenants/${tenantId}/status`,
    method: 'put',
    params: { status }
  })
}

// 获取租户配置
export function getTenantConfig(tenantId) {
  return request({
    url: `/api/admin/tenants/${tenantId}/config`,
    method: 'get'
  })
}

// 更新租户配置
export function updateTenantConfig(tenantId, config) {
  return request({
    url: `/api/admin/tenants/${tenantId}/config`,
    method: 'put',
    data: config
  })
}

// 获取所有活跃租户
export function getActiveTenants() {
  return request({
    url: '/api/admin/tenants/active',
    method: 'get'
  })
}

// 统计租户数量
export function getTenantStatistics() {
  return request({
    url: '/api/admin/tenants/statistics/count',
    method: 'get'
  })
}
